/* ============================================================================
   COD LANDER — universal landing-page JS (CraftHub / Panelverse)
   Loaded by sections/cod-lander.liquid.

   (a) CTA → order-form scrolling
       The Spider-Man original scrolled to a literal section id
       ("shopify-section-template--22928817946853__1785…") that only existed on
       that one page, so every copy of the lander had dead CTAs. The target is
       resolved at runtime instead:
         1. the `form_target` selector from the section settings
         2. the theme's own COD form, when it is switched on
         3. a COD app form (EasySell and friends)
         4. last resort: the bottom of the page

   (b) Bundle selection, FAQ accordion and the built-in COD form
       (/cart/add.js → cart attributes → /checkout).
       Every lookup is null-guarded — the Spider-Man original crashed with a
       ReferenceError here once the built-in form markup was removed in favour
       of the EasySell app block, which killed everything wired after it. The
       same script now works whether the form is present, supplied by an app,
       or absent entirely.

   Countdowns come from the shared panelverse.js [data-countdown-to] contract.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- (a) scroll */
  var AUTO_TARGETS = [
    '[data-codx-form-anchor]',
    '[data-cod-form]',
    '.es-form',
    '[class*="easysell"]',
    '[id*="easysell"]',
    'form[action*="/cart/add"]',
    '.shopify-app-block'
  ];

  function resolveTarget(btn) {
    var root = btn.closest('[data-codx-root]');
    var sel = root ? (root.getAttribute('data-form-target') || '').trim() : '';

    if (sel) {
      var wanted = null;
      try { wanted = document.querySelector(sel); } catch (e) { wanted = null; }
      if (!wanted && sel.charAt(0) !== '#' && sel.charAt(0) !== '.') {
        wanted = document.getElementById(sel);
      }
      if (wanted) return wanted;
    }

    for (var i = 0; i < AUTO_TARGETS.length; i++) {
      var found = document.querySelector(AUTO_TARGETS[i]);
      if (!found) continue;
      /* the built-in form sits inside the lander; app forms sit outside it */
      if (AUTO_TARGETS[i] === '[data-cod-form]' || !root || !root.contains(found)) {
        return found;
      }
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-scroll-form]') : null;
    if (!btn) return;
    e.preventDefault();

    var target = resolveTarget(btn);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  });

  /* -------------------------------------------- (b) bundles / FAQ / COD form */
  function initRoot(root) {
    if (!root || root.getAttribute('data-cod-init')) return;
    root.setAttribute('data-cod-init', '1');

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-cod-bundle]'));
    var sticky = root.querySelector('[data-cod-sticky]');
    var totalEl = root.querySelector('[data-cod-total]');
    var submitBtn = root.querySelector('[data-cod-submit]');
    var errorEl = root.querySelector('[data-cod-error]');
    var noProductEl = root.querySelector('[data-cod-noproduct]');
    var formCard = root.querySelector('[data-cod-form]');
    var thanksCard = root.querySelector('[data-cod-thanks]');
    var nameInput = root.querySelector('[data-cod-name]');
    var phoneInput = root.querySelector('[data-cod-phone-input]');
    var addrInput = root.querySelector('[data-cod-addr]');

    /* ---- bundle selection ---- */
    function selected() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return bundles[0] || null;
    }

    function select(el) {
      if (!el) return;
      bundles.forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (totalEl) totalEl.textContent = el.getAttribute('data-price') || '';
      var hasVariant = !!el.getAttribute('data-variant-id');
      if (submitBtn) submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    function selectById(id) {
      if (!id) return;
      var target = root.querySelector('[data-bundle-id="' + id + '"]') ||
                   root.querySelector('[data-cod-bundle="' + id + '"]');
      if (target) select(target);
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (ev) {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); select(b); }
      });
    });

    root.querySelectorAll('[data-cod-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () { selectById(btn.getAttribute('data-cod-pick')); });
    });

    /* a bundle card CTA both picks its package and scrolls to the form */
    root.querySelectorAll('[data-scroll-form]').forEach(function (btn) {
      var id = btn.getAttribute('data-scroll-form');
      if (id) btn.addEventListener('click', function () { selectById(id); });
    });

    select(root.querySelector('[data-cod-bundle][data-popular]') || bundles[0]);
    selectById(root.getAttribute('data-default-bundle'));

    /* ---- FAQ accordion ---- */
    root.querySelectorAll('[data-cod-faq]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.codx-faq__item');
        if (!item) return;
        var answer = item.querySelector('.codx-faq__a');
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (answer) answer.hidden = !open;
        var toggle = head.querySelector('.codx-faq__toggle');
        if (toggle) toggle.textContent = open ? '−' : '+';
      });
    });

    /* ---- built-in COD form (absent when a COD app supplies the form) ---- */
    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.hidden = true;
      });
    });

    function showThanks(phone, total) {
      var phoneOut = root.querySelector('[data-cod-confirm-phone]');
      var totalOut = root.querySelector('[data-cod-confirm-total]');
      if (phoneOut) phoneOut.textContent = phone;
      if (totalOut) totalOut.textContent = total;
      if (formCard) formCard.hidden = true;
      if (thanksCard) thanksCard.hidden = false;
      if (sticky) sticky.hidden = true;
    }

    function resetForm() {
      if (nameInput) nameInput.value = '';
      if (phoneInput) phoneInput.value = '';
      if (addrInput) addrInput.value = '';
      if (formCard) formCard.hidden = false;
      if (thanksCard) thanksCard.hidden = true;
      if (sticky) sticky.hidden = false;
      selectById(root.getAttribute('data-default-bundle'));
    }

    var resetLink = root.querySelector('[data-cod-reset]');
    if (resetLink) resetLink.addEventListener('click', resetForm);

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var sel = selected();
        var name = nameInput ? nameInput.value : '';
        var phone = phoneInput ? phoneInput.value : '';
        var addr = addrInput ? addrInput.value : '';

        var nameOk = name.trim().length >= 3;
        var phoneOk = /^0\d{8,9}$/.test(phone.replace(/[- ]/g, ''));
        var addrOk = addr.trim().length >= 15;

        if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
        if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
        if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);

        if (!nameOk || !phoneOk || !addrOk) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;

        var variantId = sel ? sel.getAttribute('data-variant-id') : null;
        var qty = sel ? parseInt(sel.getAttribute('data-qty') || '1', 10) : 1;
        var total = sel ? (sel.getAttribute('data-price') || '') : '';
        var label = sel ? (sel.getAttribute('data-label') || '') : '';

        showThanks(phone, total);
        if (!variantId) return; /* no product wired — the CTA is disabled anyway */

        submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'ชื่อผู้รับ': name.trim(),
                  'เบอร์โทร': phone.trim(),
                  'ที่อยู่จัดส่ง': addr.trim(),
                  'หมายเหตุ': label
                }
              })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('update failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            /* offline / theme preview — stay on the thank-you state */
            submitBtn.disabled = false;
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-codx-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

/* ── image lightbox ─────────────────────────────────────── */
(function () {
  if (window.__codxLightbox) return;
  window.__codxLightbox = true;

  var box = null, imgEl, countEl, prevBtn, nextBtn;
  var items = [], index = 0, lastFocus = null, touchX = null;

  function el(node, sel) { return node && node.nodeType === 1 ? node.closest(sel) : null; }
  function src(t) { return t.getAttribute('data-codx-zoom') || t.getAttribute('href'); }

  function mount() {
    if (box && document.body.contains(box)) return true;
    box = document.querySelector('[data-codx-lightbox]');
    if (!box) return false;
    if (box.parentNode !== document.body) document.body.appendChild(box);
    imgEl = box.querySelector('[data-codx-lightbox-img]');
    countEl = box.querySelector('[data-codx-lightbox-count]');
    prevBtn = box.querySelector('[data-codx-lightbox-prev]');
    nextBtn = box.querySelector('[data-codx-lightbox-next]');
    return true;
  }

  function show() {
    var t = items[index];
    if (!t) return;
    var inner = t.querySelector('img');
    imgEl.src = src(t);
    imgEl.alt = inner ? inner.getAttribute('alt') || '' : '';
    var multi = items.length > 1;
    if (prevBtn) prevBtn.hidden = !multi;
    if (nextBtn) nextBtn.hidden = !multi;
    if (countEl) countEl.textContent = multi ? (index + 1) + ' / ' + items.length : '';
    if (multi) {
      [items[(index + 1) % items.length], items[(index - 1 + items.length) % items.length]]
        .forEach(function (n) { if (n) { var i = new Image(); i.src = src(n); } });
    }
  }

  function open(trigger) {
    if (!mount()) return;
    var group = trigger.closest('[data-codx-zoom-group]');
    items = group ? Array.prototype.slice.call(group.querySelectorAll('[data-codx-zoom]')) : [trigger];
    index = Math.max(0, items.indexOf(trigger));
    lastFocus = document.activeElement;
    show();
    box.hidden = false;
    document.documentElement.classList.add('codx-lb-lock');
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    var closeBtn = box.querySelector('[data-codx-lightbox-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('codx-lb-lock');
    setTimeout(function () { box.hidden = true; imgEl.removeAttribute('src'); }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function step(dir) {
    if (items.length < 2) return;
    index = (index + dir + items.length) % items.length;
    show();
  }

  document.addEventListener('click', function (e) {
    var trigger = el(e.target, '[data-codx-zoom]');
    if (trigger) { e.preventDefault(); open(trigger); return; }
    if (!box || box.hidden) return;
    if (el(e.target, '[data-codx-lightbox-close]')) { close(); return; }
    if (el(e.target, '[data-codx-lightbox-prev]')) { step(-1); return; }
    if (el(e.target, '[data-codx-lightbox-next]')) { step(1); return; }
    if (e.target === box || (e.target.nodeType === 1 && e.target.hasAttribute('data-codx-lightbox-inner'))) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
  });

  document.addEventListener('touchstart', function (e) {
    if (!box || box.hidden) return;
    touchX = e.changedTouches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!box || box.hidden || touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
  }, { passive: true });
})();